import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { AnimatePresence } from 'framer-motion';
import PortfolioProvider from './context/PortfolioContext';
import MainLayout from './components/Layout/MainLayout';
import LoadingScreen from './components/UI/LoadingScreen';
import './App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function App() {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div className="App">
      <AnimatePresence mode="wait">
        {isLoading && (
          <LoadingScreen key="loader" onComplete={() => setIsLoading(false)} />
        )}
      </AnimatePresence>

      <PortfolioProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/*" element={<MainLayout />} />
          </Routes>
        </BrowserRouter>
      </PortfolioProvider>
      <Analytics />
    </div>
  );
}

export default App;